import script from "./HrTh.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTh.vue?vue&type=script&setup=true&lang=js"

import "./HrTh.vue?vue&type=style&index=0&id=7bc1d656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc1d656"]])

export default __exports__
import QTh from 'quasar/src/components/table/QTh.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTh,QTable});
